import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { LivingSituationEditPanel } from './sections/preferences/LivingSituationEditPanel'
import { useAuthState, useClient } from '@based/sdk/react'
import { useEffect, useState } from 'react'
import { NotificationsEditPanel } from './sections/preferences/NotificationsEditPanel'
import { PersonalProfileModel } from 'functions/app/dashboard/profile/view'
export const ProfilePreferences = () => {
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.preferences
  const client = useClient()
  const authState = useAuthState()
  const [profile, setProfile] = useState<PersonalProfileModel>()

  useEffect(() => {
    client
      .query('view-personal-profile', { id: authState.userId })
      .subscribe((result) => {
        setProfile(result)
      })
  }, [authState.userId, client])

  if (!profile) {
    return (
      <DashboardPageLayout>
        <Title.H3>{translations.title}</Title.H3>
      </DashboardPageLayout>
    )
  }

  return (
    <DashboardPageLayout gap="0">
      <Title.H3>{translations.title}</Title.H3>
      <Row gap="1.5rem" style={{ alignItems: 'start', flexWrap: 'wrap' }}>
        <NotificationsEditPanel profile={profile} />
        <Column
          alignItems="stretch"
          gap="1.5rem"
          style={{ flex: '1 1 20rem', minWidth: '20rem' }}
        >
          <LivingSituationEditPanel profile={profile} />
        </Column>
      </Row>
    </DashboardPageLayout>
  )
}
